import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/Tooltip';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { AusgesteuerteVorgaengeMassBearbeitung } from '@/pages/AusgesteuerteVorgaengeMassBearbeitung';
import { Layout } from './components/layout/Layout';
import { ArchivPage } from './pages/Archiv';
import { FehlerPage } from './pages/Fehler';
import { KonfigurationPage } from './pages/Konfiguration';

import { EditDokumentTypPage } from './pages/Konfiguration/DokumentTypen/EditDokumentTypPage';
import { VorgaengePage } from './pages/Vorgaenge';
import { VorgangBearbeitungPage } from './pages/VorgangBearbeitung';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/vorgaenge" replace />} />

                <Route path="vorgaenge" element={<VorgaengePage />} />
                <Route
                  path="vorgaenge/abgelaufen"
                  element={
                    <Navigate
                      to="/vorgaenge"
                      state={{
                        presetFilters: {
                          status: 'WARTEND,LAUFEND',
                          stale24h: true,
                        },
                      }}
                      replace
                    />
                  }
                />
                <Route path="archiv" element={<ArchivPage />} />

                <Route
                  path="massenverarbeitung"
                  element={<AusgesteuerteVorgaengeMassBearbeitung />}
                />
                <Route
                  path="konfiguration"
                  element={
                    <KonfigurationPage initialActiveTab={'dokumenttypen'} />
                  }
                />
                <Route
                  path="konfiguration/dokumenttypen"
                  element={
                    <KonfigurationPage initialActiveTab={'dokumenttypen'} />
                  }
                />
                <Route
                  path="konfiguration/streamserve"
                  element={
                    <KonfigurationPage initialActiveTab={'streamserve'} />
                  }
                />
                <Route path="fehler" element={<FehlerPage />} />
                <Route
                  path="konfiguration/debug"
                  element={<KonfigurationPage initialActiveTab="debug" />}
                />
                <Route
                  path="vorgaenge/:id/abarbeitungen/:abarbeitungId/schritte/:schrittId"
                  element={<VorgangBearbeitungPage />}
                />
                <Route
                  path="vorgaenge/:id"
                  element={<VorgangBearbeitungPage />}
                />
                <Route
                  path="konfiguration/dokumenttypen/:externalId"
                  element={<EditDokumentTypPage />}
                />
              </Route>
            </Routes>
          </BrowserRouter>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
          <Toaster
            duration={5000}
            position="top-right"
            expand
            visibleToasts={5}
          />
        </TooltipProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
